<template>
  <div class="blockcont emr-viewer-log">
    <h4 class="smalltitle">EMR Viewer Log</h4>
    <p>EMR note views during impersonated sessions.</p>
    <p v-if="loading" role="status">Loading EMR viewer logs...</p>
    <div v-else-if="error" role="alert">
      {{ error }} <button class="btn btn-default" @click="getLogs">Retry</button>
    </div>
    <template v-else>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>View Date</th>
              <th>Impersonated By</th>
              <th>User</th>
              <th>Patient ID</th>
              <th>Encounter Note Date</th>
              <th>Note Type</th>
              <th>Doctor</th>
              <th>Bill</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in histories" :key="item._id">
              <td>{{ formatFullTime12Hour(item.createdAt || item.time) }}</td>
              <td>{{ item.impersonatedBy || 'N/A' }}</td>
              <td>{{ item.userAction && (item.userAction.fullName || item.userAction.email) || 'N/A' }}</td>
              <td>{{ item.patientId || 'N/A' }}</td>
              <td>{{ formatFullTime12Hour(item.encounterDate) }}</td>
              <td>{{ item.type || 'N/A' }}</td>
              <td>{{ item.doctor && item.doctor.fullName || 'N/A' }}</td>
              <td>{{ item.billMrn || 'N/A' }}</td>
            </tr>
            <tr v-if="!histories.length"><td colspan="8">No EMR viewer logs found for this clinic.</td></tr>
          </tbody>
        </table>
      </div>
      <p v-if="total">Total: {{ total }}</p>
    </template>
    <pagination v-show="!loading && !error" :current-page="page" :per-page="perPage"
                :total="total" :total-pages="Math.ceil(total / perPage)"
                @updatePerPage="updatePerPage" />
  </div>
</template>

<script>
import Pagination from '@/global/Pagination.vue'
import CommonMixin from '@/mixins/general/CommonMixin.vue'
import httpClient from '@/client'

export default {
  name: 'TabEmrViewerLog',
  components: { Pagination },
  mixins: [CommonMixin],
  props: {
    clinicId: { type: [Number, String], required: true }
  },
  data () {
    return { histories: [], page: 1, perPage: 10, total: 0, loading: false, error: '', requestId: 0 }
  },
  watch: {
    clinicId () {
      this.page = 1
      this.histories = []
      this.total = 0
      this.getLogs()
    }
  },
  mounted () {
    this.getLogs()
  },
  beforeDestroy () {
    this.requestId++
  },
  methods: {
    updatePerPage (data) {
      this.page = Number(data.currentPage)
      this.perPage = Number(data.perPage)
      this.getLogs()
    },
    async getLogs () {
      const requestId = ++this.requestId
      this.loading = true
      this.error = ''
      try {
        const response = await httpClient.get('/users/clinic-emr-viewer-log/' + this.clinicId, {
          params: { page: this.page, perPage: this.perPage }
        })
        if (requestId !== this.requestId) return
        if (response.data.s !== 200) throw new Error(response.data.msg)
        this.histories = response.data.data.histories
        this.page = response.data.data.currentPage
        this.total = response.data.data.total
      } catch (e) {
        if (requestId !== this.requestId) return
        this.histories = []
        this.total = 0
        this.error = 'Unable to load EMR viewer logs. Please try again.'
      } finally {
        if (requestId === this.requestId) this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.table {
  min-width: 1100px;
}
th, td {
  vertical-align: top !important;
  overflow-wrap: anywhere;
}
</style>
